<template>
  <div :class="['spinner', color]">
    <div class="bounce1"></div>
    <div class="bounce2"></div>
    <div class="bounce3"></div>
  </div>
</template>

<script>
  export default {
    name: 'x-spinner',

    props: {
      color: {
        type: String,
        default: 'default'
      }
    }
  }
</script>

<style lang='scss' rel='stylesheet/scss'>
  @import '~@/styles/vars.scss';

  // Spinner from SpinKit
  .spinner {
    width: 4rem;
    height: 4rem;
    text-align: center;
    margin: 0 0.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .spinner > div {
    width: 0.8rem;
    height: 0.8rem;
    background-color: #FFF;

    border-radius: 100%;
    display: inline-block;
    -webkit-animation: sk-bouncedelay 1.4s infinite ease-in-out both;
    animation: sk-bouncedelay 1.4s infinite ease-in-out both;
  }

  .spinner.green > div {
    background-color: $color-meadow;
  }

  .spinner.dark > div {
    background-color: $color-shark;
  }

  .spinner .bounce1 {
    -webkit-animation-delay: -0.32s;
    animation-delay: -0.32s;
  }

  .spinner .bounce2 {
    -webkit-animation-delay: -0.16s;
    animation-delay: -0.16s;
  }

  @-webkit-keyframes sk-bouncedelay {
    0%, 80%, 100% { -webkit-transform: scale(0) }
    40% { -webkit-transform: scale(1.0) }
  }

  @keyframes sk-bouncedelay {
    0%, 80%, 100% {
      -webkit-transform: scale(0);
      transform: scale(0);
    } 40% {
      -webkit-transform: scale(1.0);
      transform: scale(1.0);
    }
  }
</style>
